<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <el-tabs v-model="activedTab" class="tabpane-mode2" @tab-click="allotTabClick">
          <el-tab-pane label="分配管理" name="allotManagement"></el-tab-pane>
          <el-tab-pane label="计划任务" name="allotTaskSchedule"></el-tab-pane>
        </el-tabs>
        <el-card>
          <el-button type="primary" @click="openAddDialog">添加计划任务</el-button>
          <span style="margin-left: 30px; color: #999">说明：“默认计划”会在当日的计划执行结束后被触发。</span>
        </el-card>
        <jm-table-list url="/training/allot_management/scheduleList" :refresh.sync="refresh" row-key="id"
                       :search-data="searchData" :page-size.sync="pageSize">
          <el-table-column fixed="right" slot="lastColumn" label="操作" class-name="scope-button-list">
            <template slot-scope="scope">
              <el-button type="success" size="small" icon="el-icon-caret-right"
                         @click="runSchedule(scope.row.id)">立即执行</el-button>
              <el-button type="primary" size="small" @click="openEditDialog(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="deleteSchedule(scope.row.id)"
                         :disabled="!!scope.row.is_default">删除</el-button>
            </template>
          </el-table-column>
        </jm-table-list>

        <!--编辑弹窗 start-->
        <el-dialog :title="!editForm.id ? '创建任务计划':'修改任务计划'" :visible.sync="editLock" width="600px">
          <el-form :model="editForm" :label-width="formLabelWidth">
            <el-form-item label="计划时段：">
              <span v-if="editForm.is_default">默认计划</span>

              <el-row v-else>
                <el-col :span="24" style="padding-bottom:20px">
                  <el-date-picker v-model="editForm.plan_date" class="jm-input400" type="date" value-format="yyyy-MM-dd"
                                  placeholder="计划日期" />
                </el-col>
                <el-col :span="12">
                  <el-time-select v-model="editForm.plan_time_from" class="jm-input175" placeholder="计划开始时间"
                                  :picker-options="{ start: '00:00', step: '00:10', end: '23:00' }" />
                </el-col>
                <el-col :span="12">
                  <el-time-select v-model="editForm.plan_time_to" class="jm-input175" placeholder="计划结束时间"
                                  :picker-options="{ start: '01:00', step: '00:10', end: '23:50', minTime: editForm.plan_time_from }" />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="老师列表：">
              <el-select class="jm-input400" v-model="editForm.teachers" clearable filterable multiple>
                <el-option-group v-for="(group, k) in trainingTeachers" :key="k" :label="k">
                  <el-option v-for="item in group" :key="`${item.country}_${item.userid}`" :label="item.truename"
                             :value="item.userid" />
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editLock = false">取 消</el-button>
            <el-button type="primary" @click="saveSchedule">确 定</el-button>
          </div>
        </el-dialog>
        <!--编辑弹窗 end-->
      </div>
    </div>
  </div>
</template>
<script>
import jmTableList from '@/components/data/tableList';
import student from '@/pages/student/student';

export default {
  mixins: [student],
  name: 'AllotManager',
  components: {
    jmTableList,
  },
  data() {
    return {
      activedTab: 'allotTaskSchedule',
      pageSize: 50,
      searchData: {},
      refresh: false,
      editLock: false,
      formLabelWidth: '120px',
      editForm: {},
    };
  },
  computed: {
    trainingTeachers() {
      return this.ds.training_teacher;
    },
  },
  methods: {
    allotTabClick(tab) {
      console.info(tab.name);
      if (tab.name === 'allotManagement') {
        this.$router.push({ name: 'allotManagement' });
      }
    },
    openAddDialog() {
      this.editLock = true;
      this.editForm = {
        action: 'add',
        is_default: 0,
        plan_date: '',
        plan_time_from: '',
        plan_time_to: '',
        teachers: [],
      };
    },
    openEditDialog(row) {
      this.editLock = true;
      this.editForm = Object.assign({}, row);
    },
    saveSchedule() {
      if (!this.editForm.is_default && (!this.editForm.plan_date || !this.editForm.plan_time_from || !this.editForm.plan_time_to)) {
        this.$message.error('计划时段没有设置');
        return;
      }
      if (!this.editForm.teachers.length) {
        this.$message.error('老师列表没有设置');
        return;
      }
      this.$http._post({
        url: '/training/allot_management/saveSchedule',
        data: { ...this.editForm }
      }).then(() => {
        this.editLock = false;
        this.$message.success('修改成功');
        this.refresh = true;
      });
    },
    async deleteSchedule(id) {
      try {
        await this.$confirm('确定要删除？', '删除分配计划任务');
      } catch (error) {
        return false;
      }
      try {
        await this.$http._delete({
          url: `/training/allot_management/delSchedule/id/${id}`,
        });
        this.$message.success('删除成功');
        this.refresh = true;
      } catch (error) {
        console.error(error);
      }
    },
    async runSchedule(id) {
      try {
        await this.$http._post({
          url: '/training/allot_management/runSchedule',
          data: { id: id },
        });
        this.$message.success('执行成功');
        this.refresh = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
  created() {
    this.getDatasource();
  },
  mounted() {},
};
</script>
